<template>
  <div class="motivate" :class="{'bg':answerResults!='toastError'}">
    <div class="motivate-box"></div>
    <div>
      <div class="title" v-if="'normalError' == answerResults && answerAdd.type != 3 && answerAdd.type != 4 && answerAdd.type != 5">
      <div class="err"></div>
      <div class="answer">你的答案：
        <div class="answer" v-for="(item,index) in answerAdd.answer" :key="index">
          <div class="txt" v-if="item.type == 0">{{ item.value[0] }}</div>
            <div class="genhao" v-if="item.type == 2">
              <span class="kaifang">{{ item.value[0] }}</span>
              <span class="beikaifang">{{ item.value[1] }}</span>
            </div>
            <div class="pingfang" v-if="item.type == 3">
              <span class="dishu">{{ item.value[0] }}</span>
              <span class="mi">{{ item.value[1] }}</span>
            </div>
            <div class="fenshu" v-if="item.type == 1">
              <div class="zhengshu">{{ item.value[2] }}</div>
              <div class="fenshi">
                <span class="fenzi">{{ item.value[0] }}</span>
                <p class="line"></p>
                <span class="fenmu">{{ item.value[1] }}</span>
              </div>
            </div>
        </div>
      </div>
    </div>
    <div class="title" v-if="'normalError' == answerResults && answerAdd.type != 3 && answerAdd.type != 4 && answerAdd.type != 5">
      <div class="right"></div>
      <div class="answer">正确答案：
        <div class="answer" v-for="(item,index) in answerAdd.rightAnswer" :key="index">
          <div class="txt" v-if="item.type == 0">{{ item.value[0] }}</div>
            <div class="genhao" v-if="item.type == 2">
              <span class="kaifang">{{ item.value[0] }}</span>
              <span class="beikaifang">{{ item.value[1] }}</span>
            </div>
            <div class="pingfang" v-if="item.type == 3">
              <span class="dishu">{{ item.value[0] }}</span>
              <span class="mi">{{ item.value[1] }}</span>
            </div>
            <div class="fenshu" v-if="item.type == 1">
              <div class="zhengshu">{{ item.value[2] }}</div>
              <div class="fenshi">
                <span class="fenzi">{{ item.value[0] }}</span>
                <p class="line"></p>
                <span class="fenmu">{{ item.value[1] }}</span>
              </div>
            </div>
        </div>
      </div>
    </div>
    </div>
    
    <div class="title" v-if="'notJoin' == answerResults">
      积极参与才能得到奖励哦！
    </div>
    <div class="tip"  v-if="'notJoin' != answerResults">
      <div class="add" v-if="answerAdd.coin > 0">
        <div class="icon"></div>
        <div class="addcoin">+{{answerAdd.coin}}</div>
      </div>
      <div class="add" v-if="answerAdd.teamScore > 0">
        <div class="dian"></div>
        <div class="addcoin adddian">+{{answerAdd.teamScore}}</div>
      </div>
    </div>
    <toast 
      :showText="answerAdd.toastText"
      :waitTime="3000"
      v-if="'toastError' == answerResults && answerAdd.toastText"
      @toastCallBack="animEnd"
    ></toast>
    <!-- <audio :src="audio_url" ref="audio"></audio> -->
  </div>
</template>
<script>
import toast from "@/components/basic/toast.vue"
import lottie from "lottie-web-limi";
export default {
  name: "motivate",
  data() {
    return {
      anim: null,
      imgSrc: "",
      tip: "",
      interval:null
      // audio_url: ""
    };
  },
  props: {
    answerResults: {
      type: [String],
      default: ""
    },
    answerAdd: {
      type: Object,
      default: ()=>{
        return {}
      }
    }
  },
  components:{
    toast
  },
  mounted() {
    //防止动画未加载成功不能消失
    this.interval = setTimeout(this.animEnd,4000);
    this.$nextTick(this.animInit);
  },
  methods: {
    animInit() {
      if(this.answerResults==='toastError')return
      let jsonPath = `/static/lottie/motivate/${this.answerResults}/${this.answerResults}.json`;
      // this.audio_url = `/static/audio/${this.answerResults}/${this.answerResults}.mp3`;
      this.anim = lottie.loadAnimation({
        container: document.querySelector(".motivate-box"), // the dom element that will contain the animation
        renderer: "svg", //svg,canvas
        loop: false,
        autoplay: false,
        path: jsonPath
        // path:"http://127.0.0.1:65005/a/a.json"
      });
      //将元素添加到DOM时
      // this.anim.addEventListener("config_ready", this.configReady);
      this.anim.addEventListener("DOMLoaded", this.domLoaded);
      //动画执行完成
      this.anim.addEventListener("complete", this.complete);
      // //当无法加载动画的一部分时
      this.anim.addEventListener("data_failed", this.dataFailed);
      
    },
    playAnim() {
      this.anim.play();
      // if (this.answerAdd.type == 3 || this.answerAdd.type == 4) return;
      // this.$refs.audio.play();
      // this.anim.goToAndStop(30, true);
      // this.anim.goToAndStop(200)
    },
    rpSuccessNum() {
      let text = "";
      const element = document.getElementById("answerType");
      if(!element)return;
      switch (this.answerResults) {
        case "normalRight":
          text = "你太棒了";
          break;
        case "normalError":
          text = "再接再厉";
          break;
        case "notJoin":
          text = "未参与";
          break;
        default:
          text = "你太棒了";
          break;
      }
      element.querySelector("tspan").innerHTML = text;
    },
    domLoaded() {
      this.$nextTick(this.rpSuccessNum);
      this.playAnim();
    },
    complete() {
      this.animEnd();
    },
    dataFailed() {
      this.animEnd();
    },
    animEnd() {
      if(this.anim){
        this.anim.removeEventListener("complete", this.complete);
        this.anim.removeEventListener("data_failed", this.dataFailed);
        this.anim.removeEventListener("DOMLoaded", this.domLoaded);
        this.anim.destroy();
      }
      clearTimeout(this.interval);
      this.anim = null;
      this.$emit("animEnd");
    }
  }
};
</script>
<style scoped lang="less" rel="stylesheet/less" scoped>
.bg{
  background: rgba(0, 0, 0, 0.6);
}
.motivate {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 80;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .motivate-box {
    margin-top: -50px;
    height: 405px;
    width: 550px;
  }
  .title {
    display: flex;
    align-items: center;
    color: #fff;
    margin-top: 20px;
    font-weight: 600;
    font-size: 20px;
  }
  .err {
    width: 23px;
    height: 23px;
    background: url(/static/img/video/err.png);
    background-size: cover;
    margin-right: 7px;
  }
  .right {
    width: 23px;
    height: 23px;
    background: url(/static/img/video/duigou_green.png);
    background-size: cover;
    margin-right: 7px;
  }
  .tip {
    display: flex;
    margin: 30px 0px 0 0;
    .add {
      background: rgba(0, 0, 0, 0.3);
      width: 100px;
      height: 35px;
      line-height: 35px;
      text-align: center;
      color: #ec8c05;
      font-size: 20px;
      border-radius: 23px;
      display: flex;
      margin-right: 25px;
      &:last-child {
        margin: 0;
      }
      .icon {
        width: 35px;
        height: 35px;
        background: url(../../../assets/img/common/coin.png) no-repeat;
        background-size: cover;
      }
      .dian {
        width: 35px;
        height: 35px;
        background: url(../../../assets/img/common/energy.png) no-repeat;
        background-size: cover;
      }
      .addcoin {
        margin-left: 15px;
      }
      .adddian {
        color: #00a074;
      }
    }
  }
}
@media screen and (max-height: 760px) {
  .motivate {
    .title {
      font-size: 16px;
    }
    .motivate-box {
      width: 400px;
      height:295px;
      margin-top: -50px;
    }
    .tip {
      .add {
        width: 80px;
        height: 28px;
        line-height: 28px;
        font-size: 18px;
        border-radius: 23px;
        &:last-child {
          margin: 0;
        }
        .icon {
          width: 28px;
          height: 28px;
        }
        .dian {
          width: 28px;
          height: 28px;
        }
      }
    }
  }
}
.answer {
  display: flex;
  align-items: center;
}
.txt {
  display: flex;
  align-items: center;
  line-height: 1.2;
  margin: 0 5px;
}
.genhao {
  .beikaifang {
    min-width: 50px;
    display: inline-block;
    height: 33px;
    line-height: 28px;
    background: url("../../../assets/img/video/genhao.png") no-repeat top left;
    margin-top: 4px;
    padding-left: 20px;
    padding-top: 2px;
    text-align: center;
    background-size: cover;
  }
  .kaifang {
    display: inline-block;
    transform: translateY(-14px);
    margin-right: -18px;
  }
}
.pingfang {
  display: flex;
  .dishu {
    margin-right: -5px;
  }
  .mi {
    font-size: 14px;
    vertical-align: 13px;
    margin: 0 6px;
  }
}
.fenshu {
  display: flex;
  justify-content: center;
  align-items: center;
  .fenshi {
    display: flex;
    flex-direction: column;
    line-height: 28px;
  }
  .line {
    display: block;
    height: 2px;
    background: #fff;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/video/motivate.vue